import { privateApi as api } from '../../../../api/backend/config';
import { IProjectRepo } from '../../interfaces/project.interface';

export class ProjectV1BaseServerRepo implements IProjectRepo {
  private readonly repoUrl =
    process.env.REACT_APP_REPOSITORY_BASESERVER + '/api/v1/project';

  public async getProjects(): Promise<any> {
    const url = this.repoUrl;
    const response = await api.get(url + 's');
    return response.data;
  }

  public async getProjectById(request: { id: string }): Promise<any> {
    const url = this.repoUrl;
    const response = await api.get(`${url}s/${request.id}`);
    return response.data;
  }

  public async createProject(request: any): Promise<any> {
    const url = this.repoUrl;
    const response = await api.post(url, request, {headers: {'Content-Type': "multipart/form-data"}});
    return response.data;
  }

  public async submitProject(projectId: string): Promise<any> {
    const url = this.repoUrl;
    const response = await api.post(`${url}s/${projectId}/submit`);
    return response.data;
  }

  public async reSubmitProject(projectId: string, payload: any): Promise<any> {
    const url = this.repoUrl;
    const response = await api.put(`${url}s/${projectId}`, payload);
    return response.data;
  }
}
